module.exports = __webpack_public_path__ + "static/media/x-logo.019d07e6.svg";